import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { InfoList } from './InfoList';
import { TechnologyInfoSection } from './TechnologyInfoSection';
import { TECHNOLOGY_MODULE_GUIDES } from './technologyModuleGuides';

type TechnologyPlaceholderPageProps = {
  moduleCode: string;
};

export function TechnologyPlaceholderPage({ moduleCode }: TechnologyPlaceholderPageProps) {
  const guide = TECHNOLOGY_MODULE_GUIDES[moduleCode];

  if (!guide) {
    return (
      <PageShell>
        <PageHeader title="Tecnologia" description="Módulo não encontrado." />
      </PageShell>
    );
  }

  return (
    <PageShell>
      <PageHeader title={guide.title} description={guide.description} />

      <div className="flex flex-col gap-4">
        <TechnologyInfoSection title="Objetivo" tone="sky">
          <p>{guide.objective}</p>
        </TechnologyInfoSection>

        <TechnologyInfoSection
          title="O que este módulo cobre"
          subtitle="Escopo previsto do cadastro e da operação"
          tone="emerald"
        >
          <InfoList items={guide.covers} />
        </TechnologyInfoSection>

        <TechnologyInfoSection
          title="Como se conecta aos demais"
          subtitle="Grafo de governança tecnológica"
          tone="violet"
        >
          <InfoList items={guide.relatesTo} />
        </TechnologyInfoSection>

        <TechnologyInfoSection
          title="Resultados esperados"
          subtitle="Valor para operação, qualidade e auditoria"
          tone="amber"
        >
          <InfoList items={guide.outcomes} />
        </TechnologyInfoSection>

        <TechnologyInfoSection title="Status" tone="slate">
          <p>
            Módulo em construção. As seções acima descrevem o desenho-alvo; o cadastro e os vínculos
            serão implementados nas próximas entregas.
          </p>
        </TechnologyInfoSection>
      </div>
    </PageShell>
  );
}
